import { client, unwrap } from './client';

export interface Account {
  id: string;
  name: string;
  email: string;
  companyName: string | null;
  status: string;
  billingPlan: string;
  prepaidBalance: number;
  monthlySpend: number;
  monthlyLimit: number;
  rateLimitRpm: number;
  rateLimitTpm: number;
  webhookUrl: string;
  createdAt: string;
}

export const getMe = (): Promise<Account> =>
  unwrap(client.get('/inference-customer/me'));

export const updateWebhook = (webhookUrl: string): Promise<{ webhookUrl: string }> =>
  unwrap(client.patch('/inference-customer/webhook', { webhookUrl }));

export const rotateWebhookSecret = (): Promise<{ webhookSecret: string }> =>
  unwrap(client.post('/inference-customer/webhook/rotate-secret'));

export interface WebhookTestResult {
  ok: boolean;
  status: number;
  latencyMs: number;
  responseSample?: string;
  error?: string;
  sentPayload: Record<string, unknown>;
  signatureSent: string;
  hint: string;
}

export const sendTestWebhook = (): Promise<WebhookTestResult> =>
  unwrap(client.post('/inference-customer/webhook/test'));
